var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_208_1",
    "data-name": "Component 208 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.507,
    height: 41.572,
    viewBox: "0 0 41.507 41.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8616",
    "data-name": "Rectangle 8616",
    width: 19.725,
    height: 19.725,
    transform: "translate(0 0)",
    fill: "#19a21a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25709",
    "data-name": "Group 25709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38446",
    "data-name": "Path 38446",
    d: "M1467.144-279.789a18.447,18.447,0,0,1,14.377,4.518,15.673,15.673,0,0,1,4.191,5.268c3.262,6.136,2.911,12.416-.3,18.481-2.466,4.656-8.8,8.97-14.355,9.265-21.848,1.16-28.076-25.674-11.159-35.325a18.13,18.13,0,0,1,7.247-2.208Zm-1.177-1.776a33.585,33.585,0,0,0-4.093,1.054,19.287,19.287,0,0,0-5.069,2.742,15.666,15.666,0,0,0-1.4,1.147,17.84,17.84,0,0,0-2.581,2.691,19.989,19.989,0,0,0-3.554,6.8,20.542,20.542,0,0,0-.682,9.16c1.142,10,11.587,19.461,23.44,17.433a20.348,20.348,0,0,0,13.226-7.5c2.906-3.361,5.466-10.106,4.371-16.038-1.572-8.516-6.758-14.375-14.326-16.779-2.339-.743-6.721-1.345-9.331-.709Z",
    transform: "translate(-1448.376 281.832)",
    fill: "#19a21a",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25712",
    "data-name": "Group 25712",
    transform: "translate(11 11.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25711",
    "data-name": "Group 25711",
    transform: "translate(0 -0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55045",
    "data-name": "Path 55045",
    d: "M391.329,5.165a5.756,5.756,0,0,1,1.635.362l2.948-2.948a2.327,2.327,0,0,1,3.236.333,2.327,2.327,0,0,1,.333,3.236l-4.7,4.7a2.327,2.327,0,0,1-3.236-.333,1.036,1.036,0,1,0-1.465,1.465,4.861,4.861,0,0,0,3.078,1.441,4.122,4.122,0,0,0,1.644-.209,3.749,3.749,0,0,0,1.443-.9l4.7-4.7a3.75,3.75,0,0,0,.9-1.443,4.123,4.123,0,0,0,.209-1.644,4.861,4.861,0,0,0-1.441-3.078A4.862,4.862,0,0,0,397.534.007a4.124,4.124,0,0,0-1.644.209,3.75,3.75,0,0,0-1.443.9l-4.065,4.065a5.424,5.424,0,0,1,.946-.015",
    transform: "translate(-382.339 0.004)",
    fill: "#19a21a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55046",
    "data-name": "Path 55046",
    d: "M10.735,337.822A5.753,5.753,0,0,1,9.1,337.46l-2.948,2.948a2.327,2.327,0,0,1-3.236-.333,2.327,2.327,0,0,1-.333-3.236l4.7-4.7a2.327,2.327,0,0,1,3.236.333A1.036,1.036,0,1,0,11.988,331a4.861,4.861,0,0,0-3.078-1.441,4.123,4.123,0,0,0-1.644.209,3.75,3.75,0,0,0-1.443.9l-4.7,4.7a3.75,3.75,0,0,0-.9,1.443,4.124,4.124,0,0,0-.209,1.644,4.862,4.862,0,0,0,1.441,3.078A4.862,4.862,0,0,0,4.53,342.98a4.124,4.124,0,0,0,1.644-.209,3.749,3.749,0,0,0,1.443-.9l4.065-4.065a5.423,5.423,0,0,1-.946.015",
    transform: "translate(0 -323.266)",
    fill: "#19a21a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGreen);
export default __webpack_public_path__ + "static/media/linkGreen.5c98194ed2fd602fac142eae5a33de04.svg";
export { ForwardRef as ReactComponent };